import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HaccpGlyph = /*#__PURE__*/createElement("g", {
  id: "haccp"
}, /*#__PURE__*/createElement("path", {
  d: "M18.4,37.9C20.3,26.6,30.2,18,42,18c8.1,0,15.2,4,19.6,10.1l3.2-0.7C59.9,20,51.5,15,42,15c-13.8,0-25.1,10.3-26.8,23.6 L18.4,37.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M65.4,47.2C63.1,57.9,53.5,66,42,66c-7.7,0-14.5-3.6-18.9-9.3l-3.2,0.7c4.9,7,13,11.5,22.1,11.5c13.4,0,24.5-9.8,26.6-22.6 L65.4,47.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M59,32.5c0.9-0.3,2.1-0.8,4-1.2c1.8-0.4,3.1-0.4,4.1,0.1c1,0.4,1.8,1.4,2.1,2.6c0.3,1.2,0.1,2.4-0.5,3.3 c-0.8,1.1-2.1,1.8-3.8,2.2c-0.3,0.1-0.6,0.1-0.8,0.1l0.9,4.1l-3.2,0.7L59,32.5z M63.5,37.1c0.2,0,0.4-0.1,0.8-0.1 c1.3-0.3,1.9-1.1,1.7-2.2c-0.2-0.9-0.9-1.4-2.2-1.1c-0.5,0.1-0.8,0.2-0.9,0.3L63.5,37.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M59.9,44.6c-0.4,0.3-1.5,0.9-2.9,1.2c-4.6,1-7.2-1.3-8-4.6c-1-4.3,1.7-7.2,5.3-8c1.4-0.3,2.6-0.3,3.2-0.2l0,2.7 c-0.6-0.1-1.4-0.1-2.4,0.1c-1.9,0.4-3.2,1.9-2.7,4.4c0.5,2.2,2.1,3.3,4.4,2.8c0.8-0.2,1.6-0.5,2.1-0.8L59.9,44.6z"
}), /*#__PURE__*/createElement("path", {
  d: "M49.6,46.9c-0.4,0.3-1.5,0.9-2.9,1.2c-4.6,1-7.2-1.3-8-4.6c-1-4.3,1.7-7.2,5.3-8c1.4-0.3,2.6-0.3,3.2-0.2l0,2.7 c-0.6-0.1-1.4-0.1-2.4,0.1c-1.9,0.4-3.2,1.9-2.7,4.4c0.5,2.2,2.1,3.3,4.4,2.8c0.8-0.2,1.6-0.5,2.1-0.8L49.6,46.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M31.4,48.4l0,3L28,52.2l0.8-13l4.3-1l6.4,11.4L36,50.4l-1.4-2.6L31.4,48.4z M33.6,45.4l-1.1-2.1c-0.3-0.6-0.8-1.6-1.1-2.3 l0,0c0,0.8,0,1.8,0,2.5l0,2.3L33.6,45.4z"
}), /*#__PURE__*/createElement("path", {
  d: "M16.6,41.9l1,4.5l4-0.9l-1-4.5l3.3-0.7l2.8,12.2l-3.3,0.7l-1.1-4.8l-4,0.9l1.1,4.8l-3.3,0.7l-2.8-12.2L16.6,41.9z"
}));
const Haccp = createSvg({
  name: 'haccp',
  path: HaccpGlyph
});

export default Haccp;
export { HaccpGlyph };
